import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import { AcademicCapIcon, ChatBubbleLeftRightIcon, MicrophoneIcon, BookOpenIcon, PencilIcon } from "@heroicons/react/24/outline";

export default function MockPage() {
  const navigate = useNavigate();

  const handleButtonClick = (path) => {
    navigate(path);
  };

  const mockTests = [
    { title: "Full Mock Test", time: "136 min", path: "/mockpage/fullmocktest",resultpath: "/mockpage/result" ,icon: AcademicCapIcon, bgColor: "bg-gray-500" },
    { title: "Listening Mock Test", time: "33 min", path: "/mockpage/listeningmocktest",resultpath: "/mockpage/listeningresult" ,icon: ChatBubbleLeftRightIcon, bgColor: "bg-purple-400" },
    { title: "Speaking Mock Test", time: "36 min", path: "/mockpage/speakingmocktest",resultpath: "/mockpage/speakingresult", icon: MicrophoneIcon, bgColor: "bg-green-300" },
    { title: "Reading Mock Test", time: "24 min", path: "/mockpage/readingmocktest",resultpath: "/mockpage/readingresult", icon: BookOpenIcon, bgColor: "bg-orange-300" },
    { title: "Writing Mock Test", time: "40 min", path: "/mockpage/writingmocktest",resultpath: "/mockpage/writingresult" ,icon: PencilIcon, bgColor: "bg-blue-300" },
  ];

  return (
    <div className="flex flex-col h-screen overflow-hidden">
    <Headerdash />
    <Sidebar />
    <div className="relative top-24 md:left-[290px] bg-gray-100 flex-1 py-10 px-4 md:px-8 mx-4 w-full md:w-[1160px] overflow-y-auto mb-20">
      <div className="  grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-6">
        {mockTests.map((test, index) => (
          <div key={index} className="bg-white rounded-lg shadow-lg p-4 md:p-6 flex flex-col items-center">
            <div className={`flex items-center justify-center mb-3 md:mb-4 ${test.bgColor} p-2 rounded-full`}>
              <test.icon className="h-10 w-10 md:h-12 md:w-12 text-white" />
            </div>
            <h2 className="text-lg md:text-xl font-bold mb-2 text-center text-gray-800">{test.title}</h2>
            <p className="text-gray-600 mb-3 md:mb-4 text-center">Time: {test.time}</p>
            <div className="flex justify-center space-x-2">
              <button
                onClick={() => handleButtonClick(test.path)}
                className="bg-violet-600 hover:bg-violet-700 text-white font-semibold py-2 px-3 md:py-2 md:px-4 rounded-sm shadow focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-transform transform hover:scale-105"
              >
                Start Mock
              </button>
              <button
                onClick={() => handleButtonClick(test.resultpath)}
                className="bg-white-600 hover:bg-violet-600 hover:text-white text-black font-semibold py-2 px-3 md:py-2 md:px-4 rounded-sm shadow focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 transition-transform transform hover:scale-105 ring-1 ring-violet-600"
              >
                View Result
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>

  );
}
